import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';

import type { PlayerInfo } from '../../types/player';

import { formatNextGame } from './utils';

const parseScheduledPlayerSport = (pick: PlayerPoolMember): Partial<PlayerInfo> => {
  const nextPlay = pick.attributes?.gameStartDateTime
    ? formatNextGame(new Date(pick.attributes?.gameStartDateTime))
    : undefined;

  return {
    nextPlay,
    meta: pick.stats,
    primaryPosition: pick.attributes?.position as string,
    game: {
      currentTeamId: pick.team_id,
      home: {
        id: pick.game?.home?.id,
        alias: pick.game?.home?.alias,
        startingPitcher: pick.game?.home?.starting_pitcher,
        probablePitcher: pick.game?.home?.probable_pitcher,
      },
      away: {
        id: pick.game?.away?.id,
        alias: pick.game?.away?.alias,
        startingPitcher: pick.game?.away?.starting_pitcher,
        probablePitcher: pick.game?.away?.probable_pitcher,
      },
    },
  };
};

export default parseScheduledPlayerSport;
